
  import { mapGetters } from 'vuex';
  export default {
    middleware: ['pages/media/pressclipping', 'breadcrumbs', 'meta-tags'],
    computed: { ...mapGetters('blog', { pressclipping: 'getPressclipping' }) }
  };
